export type FinanceCategoryKind = 'expense' | 'income' | 'transfer';
export type FinanceFxSource = 'manual' | 'api';

export type Currency = {
  code: string;
  symbol: string | null;
};

export type Account = {
  id: number;
  name: string;
  ownerMemberId: string | null;
  institution: string | null;
  accountNumber: string | null;
  currencyCode: string;
  isActive: boolean;
  sortOrder: number;
  notes: string | null;
};

export type FxRate = {
  month: string;
  currencyCode: string;
  rateToUsd: number | null;
  source: FinanceFxSource;
  fetchedAt: string | null;
};

export type Category = {
  id: number;
  parentId: number | null;
  name: string;
  kind: FinanceCategoryKind;
  isActive: boolean;
  sortOrder: number;
};

export type Transaction = {
  id: number;
  date: string;
  accountId: number | null;
  toAccountId: number | null;
  categoryId: number | null;
  currencyCode: string;
  amount: number;
  notes: string | null;
  /** Read-time FX (units of currency per 1 USD) for the transaction's month; null when missing. */
  fxRate: number | null;
  amountUsd: number | null;
};

export type Budget = {
  month: string;
  categoryId: number;
  minUsd: number | null;
  maxUsd: number | null;
  notes: string | null;
};

export const FINANCE_CATEGORY_KINDS: FinanceCategoryKind[] = ['expense', 'income', 'transfer'];

/** Default currencies seeded from the Master Data → Currencies editor. */
export const STARTER_CURRENCIES: Currency[] = [
  { code: 'USD', symbol: '$' },
  { code: 'AMD', symbol: '\u058f' },
  { code: 'CAD', symbol: '$' },
  { code: 'EUR', symbol: '\u20ac' },
  { code: 'GEL', symbol: '\u20be' },
  { code: 'CHF', symbol: 'Fr' },
  { code: 'RUB', symbol: '\u20bd' },
];
